import { useGlobalState } from '..';

export const useMovesState = () => useGlobalState('moves');
